import React from 'react';
import './ArchPage.css';
import {languageManager} from "../../utils/i18n";
import photo from '../../assets/images/arch/1.jpg'

const ArchPage = () => {
	const t = languageManager.t.bind(languageManager);

	return (
		<div className='arch_page'>
			<div className="arch_container">
				<div className="arch_text__container">
					{t('arch.subtitle').map((p, index) =>
						<p key={index}>{p}</p>
					)}
				</div>
				<img src={photo} alt="Architecture"/>
			</div>
		</div>
	);
};

export default ArchPage;